<template>
  <div class="modal-condition-action-block-container">
    <div
      id="idModalCondition"
      class="modal-condition-action-block">
      <h4 class="title">Condition</h4>

      <b-form-row class="mb-3">
        <b-col md="8">
          <b-form-group
            :class="{'error-input' : $v.dataSetup.field.$error}">
            <label> Column </label>
            <j-single-select
              v-model="dataSetup.field"
              :error-required="false"
              :options="filteredFieldOptions"
              label="name"/>
          </b-form-group>
        </b-col>

        <b-col md="4">
          <b-form-group
            :class="{'error-input' : $v.dataSetup.operator.$error}">
            <label> Operator </label>
            <j-single-select
              v-model="dataSetup.operator"
              :error-required="false"
              :options="filteredOperatorOptions"
              :disabled="!dataSetup.field"/>
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row
        v-if="isShowValueField"
        class="mb-3">
        <b-col>
          <b-form-group
            v-if="dataSetup.operator !== 'between'"
            :class="{'error-input' : $v.dataSetup.value.$error}">

            <label> Value </label>
            <j-tooltip-create-view
              v-if="showTooltip"
              :custom="true"
              :description="infoTooltip"
              :type="typeValue"
              class="d-inline-flex"/>
            <j-input
              v-model="dataSetup.value"
              :error-required="false"
              :disabled="!dataSetup.operator || !dataSetup.field"/>
          </b-form-group>

          <div v-else>
            <label> Value </label>
            <b-form-group
              :class="{'error-input' : $v.dataSetup.fromValueBetween.$error}">
              <p class="label-value">From</p>
              <j-input
                v-model="dataSetup.fromValueBetween"
                :error-required="false"
                type="number"
                class="mb-3"/>
            </b-form-group>
            <b-form-group
              :class="{'error-input' : $v.dataSetup.toValueBetween.$error}">
              <p class="label-value">To</p>
              <j-input
                v-model="dataSetup.toValueBetween"
                :error-required="false"
                type="number"/>
            </b-form-group>
          </div>
        </b-col>
      </b-form-row>

      <b-form-row>
        <b-col md="12">
          <div class="d-flex justify-content-end">
            <button
              class="button-border mr-2"
              @click="closeModal">
              Close
            </button>

            <button
              class="button-blue"
              @click="submitForm">
              Apply
            </button>
          </div>
        </b-col>
      </b-form-row>
    </div>
  </div>
</template>

<script>
import { required, requiredIf } from 'vuelidate/lib/validators';
import jTooltipCreateView from '@/components/tooltip/jTooltipCreateView';

export default {
  components: { jTooltipCreateView },
  props: {
    listField: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Object,
      default: () => {},
    },
    columns: {
      type: Array,
      default: () => [],
    },
    conditions: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: 'form',
    },
  },

  data() {
    return {
      dataSetup: {
        field: null,
        operator: null,
        value: null,
        fromValueBetween: null,
        toValueBetween: null,
      },
      operatorOptions: [
        {
          id: 'is',
          text: 'Is',
        },
        {
          id: 'in',
          text: 'In',
        },
        {
          id: 'is_not',
          text: 'Is Not',
        },
        {
          id: 'like',
          text: 'Like',
        },
        {
          id: 'is_not_like',
          text: 'Not Like',
        },
        {
          id: 'is_null',
          text: 'Is Null',
        },
        {
          id: 'is_not_null',
          text: 'Is Not Null',
        },
        {
          id: '>',
          text: '>',
        },
        {
          id: '<',
          text: '<',
        },
        {
          id: '>=',
          text: '>=',
        },
        {
          id: '<=',
          text: '<=',
        },
        {
          id: '=',
          text: '=',
        },
        {
          id: '!=',
          text: '!=',
        },
        {
          id: 'between',
          text: 'Between',
        },
      ],
      isShowValueField: false,
    };
  },

  computed: {
    filteredOperatorOptions() {
      const options = this.type === 'form' ? this.operatorOptions.filter(i => i.id !== 'is_not_like') : this.operatorOptions;

      const type = this.checkFieldType(this.dataSetup.field);
      const numberOnlyTypes = ['between', '>', '<', '>=', '<='];
      if (type === 'big_integer' || type === 'decimal' || type === 'integer' || type === 'timestamp' || type === 'float' || type === 'small_integer' || type === 'number') {
        return options;
      }
      return options.filter(f => !numberOnlyTypes.includes(f.id));
    },

    filteredFieldOptions() {
      const fieldExist = this.conditions.map(i => i.field);

      if (fieldExist.length && this.data && this.data.field) {
        const filteredFieldExist = fieldExist.filter(i => i !== this.data.field);
        return this.listField.filter(f => !filteredFieldExist.includes(f.id));
      } else if (fieldExist.length) {
        return this.listField.filter(f => !fieldExist.includes(f.id));
      }
      return this.listField;
    },

    typeValue() {
      if (this.dataSetup.operator === '>' || this.dataSetup.operator === '<' || this.dataSetup.operator === '>=' || this.dataSetup.operator === '<=' || this.dataSetup.operator === 'between') {
        return 'number';
      }
      return 'text';
    },

    showTooltip() {
      return this.dataSetup.operator === 'in';
    },

    infoTooltip() {
      return `
        <div style="font-size: 9px; font-family: Poppins-Medium; color: #5A5B5A;"> How to input value with IN operator? </div>
        <div style="font-size: 9px; font-family: Poppins-Regular; color: #5A5B5A;">
          a. Condition with IN operator must be an Array values<br>
          ex: ["Value1", "Value2"]<br>
          b. The input can also written as variable with Array values<br>
            ex:<br>
            var arrayData = ["Value1","Value2"]<br>
            put variable arrayData to the filter field
        <div>
      `;
    },
  },

  watch: {
    // eslint-disable-next-line
    'dataSetup.operator': function (val) {
      if (val === 'is_null' || val === 'is_not_null') {
        this.isShowValueField = false;
        this.dataSetup.value = null;
      } else {
        this.isShowValueField = true;
      }
    },

    'dataSetup.field': {
      handler(newValue, oldValue) {
        if (oldValue && newValue !== oldValue) {
          this.dataSetup.operator = null;
        }
      },
    },
  },

  created() {
    if (this.data) {
      const { field, operator, value } = this.data;
      this.dataSetup.field = field;
      this.dataSetup.operator = operator;
      this.dataSetup.value = operator !== 'between' ? value : null;
      this.dataSetup.fromValueBetween = operator === 'between' ? value[0] : null;
      this.dataSetup.toValueBetween = operator === 'between' ? value[1] : null;
    }
  },

  methods: {
    submitForm() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        this.$emit('submit', this.dataSetup);
      }
    },

    closeModal() {
      this.dataSetup.field = null;
      this.dataSetup.operator = null;
      this.dataSetup.value = null;
      this.dataSetup.fromValueBetween = null;
      this.dataSetup.toValueBetween = null;

      this.$emit('close');
    },

    checkFieldType(field) {
      const targetedField = this.columns.find(i => i.name === field);
      if (targetedField) return targetedField.type;
      return null;
    },
  },

  validations: {
    dataSetup: {
      field: {
        required,
      },
      operator: {
        required,
      },
      value: {
        required: requiredIf(dataSetup => dataSetup.operator && dataSetup.operator !== 'between' && dataSetup.operator !== 'is_null' && dataSetup.operator !== 'is_not_null'),
      },
      fromValueBetween: {
        required: requiredIf(dataSetup => dataSetup.operator && dataSetup.operator === 'between'),
      },
      toValueBetween: {
        required: requiredIf(dataSetup => dataSetup.operator && dataSetup.operator === 'between'),
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/visual-programming/popup/ModalConditionActionBlock.vue